import { Input, Select, Option, Typography } from '@material-tailwind/react';
import React, { useState } from 'react';
import { Search } from 'lucide-react';

const InputSearch = ({ search, array, setFilterCategoria, value, placeholder = 'Buscar' }) => {
  const renderizarOpcoes = () => {
    const opcoes = [
      <Option key="all" value="">
        Todas as Categorias
      </Option>,
    ];

    array.forEach((categoria, index) => {
      opcoes.push(
        <Option key={index} value={categoria.nome}>
          <Typography color="black" variant="h6">
            {categoria.nome.toUpperCase()}
          </Typography>
        </Option>
      );
    });

    return opcoes;
  };

  const css =
    'placeholder:text-gray-500 text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 placeholder:opacity-100  bg-white dark:bg-darkBgInput ';
  return (
    <div className="h-10 mb-2 w-full md:w-[90%] mt-2">
      <div className="flex gap-2 h-6 justify-end mx-2 ">
        <div>
          <Input
            type="Search"
            label="Buscar"
            className={`${css} `}
            labelProps={{
              className: 'hidden ',
            }}
            containerProps={{
              className: 'w-[50%] min-w-full',
            }}
            placeholder={placeholder}
            icon={<Search />}
            onChange={search}
            // value={value}
          ></Input>
        </div>
        {array && array.length > 0 && (
          <div>
            <Select
              className={`${css} `}
              labelProps={{
                className: 'hidden ',
              }}
              label="Categoria"
              onChange={setFilterCategoria}
              value={value}
            >
              {renderizarOpcoes()}
            </Select>
          </div>
        )}
      </div>
    </div>
  );
};

export default InputSearch;
